export default "__VITE_ASSET__CJjhszio__"